import React, { Component } from "react";
import { Layout, Menu, Icon, Button } from "antd";
import { removeToken, removePermissoes, removeStatus, getTipoUsuario, getTemPermissao } from "../utils/LoginManager";
import { withRouter, Link } from "react-router-dom";
import { getUsuario } from "../utils/LoginManager";
import Colors from '../utils/Colors';
import axios from "axios";
import TermosDeUsoForm from '../components/TermosDeUsoForm';

const { Sider } = Layout;
const { Item, SubMenu } = Menu;

class SideMenu extends Component {
  rootSubmenuKeys = ['cadastros', 'pedidos', 'configuracoes'];

  state = {
    openKeys: [],
    tipoUsuario: '',
    formTermosUsoVisivel: false,
    collapsed: window.innerWidth < 960 ? true : false
  };

  componentDidMount() {
    removePermissoes();

    getTipoUsuario().then(tipoUsuario => {
      this.setState({ tipoUsuario });
    })
  }

  onOpenChange = (openKeys) => {
    const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
    if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys });
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : [],
      });
    }
  }

  sair = async () => {
    // console.log('sair sair');
    // await axios.get(`/usuarios/logout`)
    //   .then(response => {
    //     console.log('sair OK');
    //     console.log('sair: ', response);

    //     // return;
    //     // removeToken();
    //     // removePermissoes();
    //     // this.props.history.push("/login");
    //   })
    //   .catch(error => {
    //     console.log('sair ERRO');
    //     // return;
    //     // removeToken();
    //     // removePermissoes();
    //     // this.props.history.push("/login");
    //   });
    // console.log('sair sair 1');

    // removeStatus();
    removeToken();
    removePermissoes();
    this.props.history.push("/login");
  };




  onTermoUsoClick = () => {
    this.setState({
      formTermosUsoVisivel: true,
    })
  }

  onCancelarClick = () => {
    this.setState({
      formTermosUsoVisivel: false
    })
  }


  toggleCollapsed = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  // onWhatsAppClick = () => {
  //   return <a href="http://api.whatsapp.com/send?1=pt_BR&phone=5544999192043" target="_blank">Suporte On-Line</a>
  // }




  render() {
    const { tipoUsuario, formTermosUsoVisivel } = this.state;
    const usuario = getUsuario();
    var windowHeight = window.innerHeight;

    // console.log('SideMenu.this.state: ', this.state);

    return (
      <div style={{ width: this.state.collapsed ? 80 : 200, background: Colors.primary }}>
        <Sider breakpoint="md" collapsedWidth="0" style={{ background: Colors.primary, width: this.state.collapsed ? 80 : 200 }}>
          <div className="side-menu-logo" style={{ height: 55, marginTop: 5, }}>
            <h1>FASTGESTOR</h1>
          </div>
        </Sider>
        <div style={{ background: Colors.primary }}>

          <Menu
            mode="vertical-left"
            theme="dark"
            openKeys={this.state.openKeys}
            onOpenChange={this.onOpenChange}
            style={{ background: Colors.primary }}
            inlineCollapsed={this.state.collapsed}
          >
            <Item>
              <Link to="/">
                <Icon type="dashboard" />
                <span>Início</span>
              </Link>
            </Item>

            <Item>
              <Link to="/agenda">
                <Icon type="calendar" />
                <span>Agenda</span>
              </Link>
            </Item>

            <SubMenu key="lancamentos" title={<span><Icon type="form" /><span>Lançamentos</span></span>}>
              <SubMenu key="lancVendas" title="Vendas">
                {getTemPermissao('OrdemServicosPage', 'cons') ? (
                  <Menu.Item key="OrdemServicosPage"><Link to="/ordemServico"><span>Ordem de Serviço</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('VendaBalcaoPage', 'cons') ? (
                  <Menu.Item key="VendaBalcaoPage"><Link to="/vendaBalcao"><span>Venda Balcão</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('PedidosPage', 'cons') ? (
                  <Menu.Item key="PedidosPage"><Link to="/pedidos"><span>Pedidos</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('VendasPage', 'cons') ? (
                  <Menu.Item key="VendasPage"><Link to="/vendas"><span>Gerenciar Vendas</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('OrcamentosPage', 'cons') ? (
                  <Menu.Item key="OrcamentosPage"><Link to="/orcamentos"><span>Orçamentos</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('CondicionaisPage', 'cons') ? (
                  <Menu.Item key="CondicionaisPage"><Link to="/condicional"><span>Gerenciar Condicionais</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('EstornoVendasPage', 'cons') ? (
                  <Menu.Item key="EstornoVendasPage"><Link to="/estornarVendas"><span>Estornar/Cancelar Vendas</span></Link></Menu.Item>
                ) : null}
              </SubMenu>

              {getTemPermissao('NotasFiscaisEmissaoPage', 'cons') ? (
                <Menu.Item key="NotasFiscaisEmissaoPage"><Link to="/emissaonf"><span>Notas Fiscais</span></Link></Menu.Item>
              ) : null}

              <SubMenu key="lancFinanc" title="Financeiro">
                {getTemPermissao('TitulosPage', 'cons') ? (
                  <Menu.Item key="TitulosPage"><Link to="/titulos"><span>Lançamentos Financeiro</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('ReparcelamentoPage', 'cons') ? (
                  <Menu.Item key="ReparcelamentoPage"><Link to="/reparcelamento"><span>Reparcelamento</span></Link></Menu.Item>
                ) : null}
              </SubMenu>

              <SubMenu key="lancContratos" title="Contratos">
                {getTemPermissao('ContratosPage', 'cons') ? (
                  <Menu.Item key="ContratosPage"><Link to="/contratos"><span>Controle de Contratos</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('ContratosFaturamentoPage', 'cons') ? (
                  <Menu.Item key="ContratosFaturamentoPage"><Link to="/contratosFaturamento"><span>Faturamento</span></Link></Menu.Item>
                ) : null}
              </SubMenu>

              <SubMenu key="lancEstoque" title="Estoque">
                {getTemPermissao('ComprasPage', 'cons') ? (
                  <Menu.Item key="ComprasPage"><Link to="/compras"><span>Compras</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('InventarioPage', 'cons') ? (
                  <Menu.Item key="InventarioPage"><Link to="/inventario"><span>Ajuste do Estoque</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('EtiquetasPage', 'cons') ? (
                  <Menu.Item key="EtiquetasPage"><Link to="/etiquetas"><span>Impressão de Etiquetas</span></Link></Menu.Item>
                ) : null}
              </SubMenu>
            </SubMenu>

            <SubMenu key="consultas" title={<span><Icon type="profile" /><span>Relatórios</span></span>}>
              <SubMenu key="consultaFinanc" title="Financeiro">
                {getTemPermissao('CaixasPage', 'cons') ? (
                  <Menu.Item key="CaixasPage"><Link to="/caixas"><span>Caixa</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('FichaFinanceiraPage', 'cons') ? (
                  <Menu.Item key="FichaFinanceiraPage"><Link to="/fichaFinanc"><span>Ficha Financeira</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('CtasPagarRecPage', 'cons') ? (
                  <Menu.Item key="CtasPagarRecPage"><Link to="/ctaspagarrec"><span>Contas à Pagar/Receber</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('BalancoFinancPage', 'cons') ? (
                  <Menu.Item key="BalancoFinancPage"><Link to="/balancoFinanc"><span>Balanço Financeiro</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('ResumoCtasPage', 'cons') ? (
                  <Menu.Item key="ResumoCtasPage"><Link to="/resumoCtas"><span>Resumo por Contas</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('ComissaoVendasPage', 'cons') ? (
                  <Menu.Item key="ComissaoVendasPage"><Link to="/comissaoVendas"><span>Comissão Vendedores</span></Link></Menu.Item>
                ) : null}
              </SubMenu>

              <SubMenu key="consultaVendas" title="Vendas">
                {getTemPermissao('PedidosProdutosPage', 'cons') ? (
                  <Menu.Item key="PedidosProdutosPage"><Link to="/pedidosProdutos"><span>Produtos Vendidos</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('OrdemServicoServicosPage', 'cons') ? (
                  <Menu.Item key="OrdemServicoServicosPage"><Link to="/osServicos"><span>Serviços Executados</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('OrdemServicoAvulsosPage', 'cons') ? (
                  <Menu.Item key="OrdemServicoAvulsosPage"><Link to="/osAvulsos"><span>Itens Avulsos das O.S </span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('CarteiraClientesPage', 'cons') ? (
                  <Menu.Item key="CarteiraClientesPage"><Link to="/carteiraClientes"><span>Carteira de Clientes</span></Link></Menu.Item>
                ) : null}
              </SubMenu>

              <SubMenu key="consultaEstoque" title="Estoque">
                {getTemPermissao('ComprasProdutosPage', 'cons') ? (
                  <Menu.Item key="ComprasProdutosPage"><Link to="/comprasProdutos"><span>Produtos Comprados</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('FichaEstoquePage', 'cons') ? (
                  <Menu.Item key="FichaEstoquePage"><Link to="/fichaEstoque"><span>Ficha Estoque</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('EstoqueAtualPage', 'cons') ? (
                  <Menu.Item key="EstoqueAtualPage"><Link to="/estoqueAtual"><span>Estoque Atual</span></Link></Menu.Item>
                ) : null}
              </SubMenu>
            </SubMenu>

            <SubMenu key="cadastros" title={<span><Icon type="database" /><span>Cadastros</span></span>}>
              {getTemPermissao('PessoasPage', 'cons') ? (
                <Menu.Item key="PessoasPage"><Link to="/clientes"><span>Cliente/Fornecedor</span></Link></Menu.Item>
              ) : null}

              <SubMenu key="cadProduto" title="Produtos">
                {getTemPermissao('ProdutosPage', 'cons') ? (
                  <Menu.Item key="ProdutosPage"><Link to="/produtos"><span>Produtos</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('GruposProdutosPage', 'cons') ? (
                  <Menu.Item key="GruposProdutosPage"><Link to="/gruposProdutos"><span>Grupos</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('MarcasPage', 'cons') ? (
                  <Menu.Item key="MarcasPage"><Link to="/marcas"><span>Marcas</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('MedidasPage', 'cons') ? (
                  <Menu.Item key="MedidasPage"><Link to="/medidas"><span>Unidades de Medida</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('ProdutoTamanhoPage', 'cons') ? (
                  <Menu.Item key="ProdutoTamanhoPage"><Link to="/produtosTamanho"><span>Tamanho Grade</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('ProdutoCorPage', 'cons') ? (
                  <Menu.Item key="ProdutoCorPage"><Link to="/produtosCor"><span>Cor Grade</span></Link></Menu.Item>
                ) : null}
              </SubMenu>

              <SubMenu key="cadServicos" title="Serviços">
                {getTemPermissao('ServicosPage', 'cons') ? (
                  <Menu.Item key="ServicosPage"><Link to="/servicos"><span>Serviços</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('GruposServicosPage', 'cons') ? (
                  <Menu.Item key="GruposServicosPage"><Link to="/gruposServicos"><span>Grupos</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('CheckListOSPage', 'cons') ? (
                  <Menu.Item key="CheckListOSPage"><Link to="/checklistos"><span>CheckList OS</span></Link></Menu.Item>
                ) : null}
              </SubMenu>

              <SubMenu key="cadFinanceiro" title="Financeiro">
                {getTemPermissao('CondPagtosPage', 'cons') ? (
                  <Menu.Item key="CondPagtosPage"><Link to="/condPagtos"><span>Condições de Pagtos</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('TipoDocsPage', 'cons') ? (
                  <Menu.Item key="TipoDocsPage"><Link to="/tipoDocs"><span>Tipos Documentos</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('PlanoContasPage', 'cons') ? (
                  <Menu.Item key="PlanoContasPage"><Link to="/planoContas"><span>Plano de Contas</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('CtasCorrentesPage', 'cons') ? (
                  <Menu.Item key="CtasCorrentesPage"><Link to="/ctaCorrentes"><span>Contas Correntes</span></Link></Menu.Item>
                ) : null}
              </SubMenu>

              {getTemPermissao('TipoAgendasPage', 'cons') ? (
                <Menu.Item key="TipoAgendasPage"><Link to="/tiposAgendas"><span>Tipos de Agendas</span></Link></Menu.Item>
              ) : null}
              {getTemPermissao('GruposPessoasPage', 'cons') ? (
                <Menu.Item key="GruposPessoasPage"><Link to="/gruposPessoas"><span>Grupos de Pessoas</span></Link></Menu.Item>
              ) : null}

            </SubMenu>


            <Item>
              <Link to="/configuracoes">
                <Icon type="setting" />
                <span>Configurações</span>
              </Link>
            </Item>

            <Item>
              <a href="" onClick={this.sair}>
                <Icon type="logout" />
                <span>Sair</span>
              </a>
            </Item>
          </Menu>


          <div style={{ paddingLeft: 5, paddingRight: 3, paddingTop: 10 }}>

            <div style={{ textAlign: 'center', margin: 10, marginTop: 30 }}>
              <Button type="ghost" htmlType="button" onClick={this.toggleCollapsed} style={{ width: "100%" }}>
                <Icon type={this.state.collapsed ? 'double-right' : 'double-left'} />
              </Button>
            </div>

            <div style={{ height: 1, marginBottom: 10, width: "100%", borderWidth: 1, backgroundColor: Colors.dividerLight }} />
            <Icon type="user" className="iconeLayout" style={{ color: Colors.textDisabledLight }} />
            <span style={{ color: Colors.textDisabledLight, marginLeft: 5 }}>{usuario.usu_nome} </span>


            <div style={{ height: 1, marginBottom: 10, marginTop: 10, width: "100%", borderWidth: 1, backgroundColor: Colors.dividerLight }} />
            <Icon type="message" className="iconeLayout" style={{ color: Colors.textDisabledLight }} />
            <a
              href="http://api.whatsapp.com/send?1=pt_BR&phone=5544998459635"
              target="_blank"
              style={{ cursor: 'pointer', color: Colors.textDisabledLight, fontStyle: "italic", textDecorationLine: "underline", marginLeft: 5 }}>
              Suporte On-Line
            </a>


            <div style={{ height: 1, marginBottom: 10, marginTop: 10, width: "100%", borderWidth: 1, backgroundColor: Colors.dividerLight }} />
            <Icon type="file-text" className="iconeLayout" style={{ color: Colors.textDisabledLight }} />
            <a
              onClick={() => this.onTermoUsoClick()}
              style={{ cursor: 'pointer', color: Colors.textDisabledLight, fontStyle: "italic", textDecorationLine: "underline", marginLeft: 5 }}>
              Termos de Uso do Sistema
            </a>

            <TermosDeUsoForm
              visivel={formTermosUsoVisivel}
              onCancelarClick={this.onCancelarClick}
            />
          </div>

        </div>
      </div>
    );
  }
}

export default withRouter(SideMenu);



// WEBPACK FOOTER //
// ./src/layouts/SideMenu.js